import { addDays } from "./format";

/**
 * All / Today / This week filter on the Reminders page columns. Reminder dates
 * are plain "YYYY-MM-DD" strings, so everything here compares date strings —
 * no timestamps, no time zones.
 *
 * "Today" means one day away from today in the column's direction (yesterday
 * on Overdue, tomorrow on Upcoming, today itself on Callback); "This week" is
 * the Monday-to-Sunday week today falls in, clipped to the column's side of
 * today.
 */
export const REMINDER_FILTERS = [
  ["all", "All"],
  ["today", "Today"],
  ["week", "This week"],
];

/** [Monday, Sunday] of the week the given day is in. */
export const weekBounds = (day) => {
  const weekday = new Date(day + "T00:00:00Z").getUTCDay(); // 0 = Sunday
  const monday = addDays(day, -((weekday + 6) % 7));
  return [monday, addDays(monday, 6)];
};

/** [from, to] date-string range for a filter on a column, or null for no limit. */
const rangeFor = (filterKey, column, today) => {
  if (filterKey === "today") {
    if (column === "overdue") return [addDays(today, -1), addDays(today, -1)];
    if (column === "upcoming") return [addDays(today, 1), addDays(today, 1)];
    return [today, today];
  }
  if (filterKey === "week") {
    const [monday, sunday] = weekBounds(today);
    if (column === "overdue") return [monday, addDays(today, -1)];
    if (column === "upcoming") return [addDays(today, 1), sunday];
    return [monday, sunday];
  }
  return null;
};

export const filterReminders = (items, filterKey, column, today, getDate = (r) => r.date) => {
  const range = rangeFor(filterKey, column, today);
  if (!range) return items;
  const [from, to] = range;
  return items.filter((item) => {
    const d = getDate(item);
    return !!d && d >= from && d <= to;
  });
};
